import { createSlice } from '@reduxjs/toolkit';

export type Tag = {
  id: number;
  name: string;
  color: string;
}

type InitialState = {
  tags: Tag[] | null;
}

const initialState: InitialState = {
  tags: null,
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setTags: (state, { payload }) => {

      state.tags = payload;
    },
  },
});

export const { setTags } = tagsSlice.actions;

export default tagsSlice.reducer;
